import { QuestionCircleOutlined } from '@ant-design/icons'
import { Col, DatePicker, Form, Row, Tooltip } from 'antd'
import React from 'react'
import { useTranslation } from 'react-i18next'

export const ProductionResultTimeForm = () => {
  const { t } = useTranslation()

  return (
    <>
      <div className='text-base font-bold mb-4'>{t('production.detail.projectResultTime')}</div>
      <Row gutter={16}>
        <Col span={6}>
          <Form.Item
            label={t('production.detail.expectProductionTime')}
            required
            name='expectProductionTime'
            rules={[{ required: true }]}
          >
            <DatePicker className='w-full' />
          </Form.Item>
        </Col>
        <Col span={6}>
          <Form.Item
            label={
              <>
                <span>{t('production.detail.expectTargetCheckTime')}</span>
                <Tooltip title={t('production.detail.expectTargetCheckTimeDescription')}>
                  <QuestionCircleOutlined className='ml-4px text-gray-500' />
                </Tooltip>
              </>
            }
            required
            name='expectTargetCheckTime'
            rules={[
              {
                required: true,
                validator: async (_, value) => {
                  return !value
                    ? Promise.reject(`${t('production.detail.expectTargetCheckTime')}是必选填项!`)
                    : Promise.resolve()
                },
              },
            ]}
          >
            <DatePicker className='w-full' />
          </Form.Item>
        </Col>
      </Row>
    </>
  )
}
